import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    flat: "",
    bordered: "",
    class: "q-pa-md"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.label) + " * ", 1),
      _createVNode(_component_q_option_group, {
        outlined: "",
        dense: "",
        rules: [_ctx.requiredRule],
        modelValue: _ctx.localModel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModel) = $event)),
        options: _ctx.accessDurationTypeOptions,
        color: "primary"
      }, null, 8, ["rules", "modelValue", "options"])
    ]),
    _: 1
  }))
}